import { useEffect, useState } from 'react';
import type { LocalMirrorPlayer, MirrorStatus } from '../obr/localMirror.ts';

/**
 * Tells the player whether their sheet will survive a reload. Quiet when all
 * is well; a visible warning otherwise, because a silent save failure is how
 * a player loses a character.
 */
const MESSAGES: Record<MirrorStatus, string> = {
  ok: 'Saved on this browser.',
  unavailable:
    'This browser is blocking storage, so your sheet will not survive a reload. Export it before you leave.',
  failed:
    'Your last change did not save to this browser (storage full or blocked). Export your crawler now.',
  corrupt:
    'Your saved sheet on this browser could not be read. A backup copy was kept. Export anything important.',
  'restore-failed':
    'Your saved sheet could not be loaded. Reload the page before making changes; your saved copy is protected until then.',
};

export function SaveStatus({ mirror }: { mirror: LocalMirrorPlayer }) {
  const [status, setStatus] = useState<MirrorStatus>(mirror.getStatus());
  useEffect(() => mirror.onStatusChange(setStatus), [mirror]);

  const warn = status !== 'ok';
  return (
    <p className={warn ? 'dcc-save-status dcc-save-warn' : 'dcc-save-status'} role={warn ? 'alert' : 'status'}>
      {MESSAGES[status]}
    </p>
  );
}
